import React from 'react';
import Header from './components/header/header';
import About from './components/about/about';
import Portofolio from './components/portofolio/portofolio';
import Footer from './components/footer/footer';

function App() {
  return (
    <div className="App">
        <Header />
        <About />
        <Portofolio />
        <Footer />
      </div>
  );
}

export default App;
